import { DownloadButton } from "_components/buttons";
import SearchInput from "_components/SearchInput";
import { CustomTable } from "_components/table/CustomTable";
import { diagnosticLoggerActions } from "_store";
import { sidePanelActions } from "_store/sidePanel.slice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export { LogsTableList };

/**
 * Tableau listant l'ensemble des logs recus du Diagnostic Logger
 * @returns 
 */
function LogsTableList ({vin}) {

    const logs = useSelector(state => state.diagnosticLogger?.logs);
    const dispatch = useDispatch();   
    const [filteredData, setFilteredData] = useState([]);

    /*useEffect(() => {
        if (logs) {
            console.log(logs)
        }
    }, [logs]);*/

    useEffect(() => {
        if (vin) {
            dispatch(diagnosticLoggerActions.getData(vin));
        }
    }, [vin]);

    const handleFilteredData = (newFilteredData) => {
        if (JSON.stringify(newFilteredData) !== JSON.stringify(filteredData)) {
            setFilteredData(newFilteredData);
        }
    };

    const handleShowSidePanel = (alert) => {
        dispatch(sidePanelActions.openPanel({ type: 'diagLog', data: alert }));        
    }

    const headers = [
        { label: 'Time TIGR', key: 'TIME_TIGR', type: 'string', canToggle: false, visible: true },
        { label: 'Time Diag.Logger', key: 'TIME_DIAGNOSTIC_LOGGER', type: 'string', canToggle: false, visible: true },
        { label: 'Time Diff', key: 'TIME_DIFF', type: 'string', canToggle: false, visible: true },
        { label: "ECU name", key: 'ecu_name', type: 'stringe', canToggle: false, visible: true },
        { label: "ECU hex", key: 'ecu_hex', type: 'string', canToggle: false, visible: true },
        { label: 'SPNHEX', key: 'SPNHEX', type: 'string', canToggle: false, visible: true },
        { label: 'FMI dl hex', key: 'fmi_dl_hex', type: 'string', canToggle: false, visible: true },
        { label: 'DTC code hex', key: 'dtc_code_hex', type: 'string', canToggle: false, visible: true },
        { label: 'Description', key: 'description', type: 'string', canToggle: false, visible: true, width: '300' },
        { label: 'Couleur', key: 'color', type: 'string', canToggle: false, visible: true },        
        { label: 'Texte affiché', key: 'text_displayed', type: 'string', canToggle: false, visible: true }, 
        { label: '', key: 'log_info', type: 'action', action: handleShowSidePanel, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'Voir les variables de contexte'},   
    ]

    return (
        <>
            {logs ? (<div className="custom-table-container">
            <div className={'flex justify-between items-center'}>
                    <div className="flex items-center w-full justify-between">
                        <div>
                            <span className={'title-customtable'}>{logs.length}</span>
                            <span className={'small-title-customtable'}> Log{logs.length > 1 ? 's' : ''} </span>
                        </div>   
                        
                        <div className="float-right flex gap-4">
                            <SearchInput data={logs} onFilteredData={handleFilteredData} />    
                            <DownloadButton title={'Données Diagnostic Logger'} headers={headers} data={filteredData} />                        
                        </div>                     
                        
                    </div>
                    
                </div>
                
                <div className={"my-4 "}>
                    <CustomTable data={filteredData} headers={headers} maxHeight={'70vh'}/>
                </div>
            </div>) : (
            <div className="w-full min-h-[50vh] flex justify-center items-center">
                <span className="text-lg text-gray-700 italic text-center">
                    Veuillez sélectionner un numéro VIN pour afficher des données
                </span>
            </div>
            )} 
        </>
    )
}